import { useLocation } from 'react-router-dom';

export function useGuidesBase() {
  const location = useLocation();
  return location.pathname.startsWith('/poradniki') ? '/poradniki' : '/app/guides';
}
